import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { contact, navLinks } from '../../data/site';
import { Button } from '../ui/Button';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return <header className={`sticky top-0 z-50 border-b bg-white transition-[border-color,box-shadow] duration-200 ${scrolled ? 'border-afb-line shadow-[0_6px_20px_-14px_rgba(11,11,12,0.35)]' : 'border-transparent'}`} data-id="element-150" data-mp="3abnpb3izzy4">
      <div className="mx-auto flex h-[72px] max-w-page items-center justify-between gap-6 px-5 lg:px-8" data-id="element-151" data-mp="6uvojh6exfwr">
        <a href="#top" className="shrink-0" aria-label="Australian Flow Batteries home" data-id="element-152" data-mp="btgnzedubvk5">
          <img src={contact.logo} alt="Australian Flow Batteries" className="h-9 w-auto" data-id="element-153" data-mp="gmt22ukw8jyn" />
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-154" data-mp="lj9qzqzx32cs">
          <ul className="flex items-center gap-8" data-id="element-155" data-mp="3k2gpdotb40vi">
            {navLinks.map(link => <li key={link.label} data-id="element-156" data-mp="3p11n9hl368gs">
                <a href={link.href} className="text-[15px] font-medium text-afb-ink/75 transition-colors duration-150 hover:text-afb-ink" data-id="element-157" data-mp="3p22zvqhr330m">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-158" data-mp="199du7x971039">
          <a href={contact.phoneHref} className="hidden text-[15px] font-medium text-afb-ink transition-colors duration-150 hover:text-afb-teal xl:block" data-id="element-159" data-mp="1dbqwucsn8hvt">
            {contact.phoneDisplay}
          </a>
          <Button href="#contact" size="md" className="hidden sm:inline-flex" data-id="element-160" data-mp="35c8tpjrp6z4y">
            Request a demo
          </Button>
          <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center rounded-btn border border-afb-line text-afb-ink lg:hidden" data-id="element-161" data-mp="3jca3jopxxgwk">
            {open ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-162" data-mp="30f8tvqlfysma" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-163" data-mp="2vnh4hje0usxq" />}
          </button>
        </div>
      </div>

      {open && <nav id="mobile-nav" aria-label="Mobile" className="border-t border-afb-line bg-white px-5 pb-6 pt-2 lg:hidden" data-id="element-164" data-mp="27xecf3a3xmz4">
          <ul data-id="element-165" data-mp="22y1tgtmcx01t">
            {navLinks.map(link => <li key={link.label} data-id="element-166" data-mp="igso3d99ialj">
                <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-afb-line py-4 text-base font-medium text-afb-ink" data-id="element-167" data-mp="ifpw1207e241">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <Button href="#contact" onClick={() => setOpen(false)} className="mt-5 w-full" data-id="element-168" data-mp="efp5iizty0gm">
            Request a demo
          </Button>
        </nav>}
    </header>;
}